import React from 'react';

const InfoUnavailable = () => {
  return (
    <div className="">
      <p className='fst-italic mb-0'>Information not provided by data source</p>
    </div>
  );
};

export default InfoUnavailable;
